import {
  interacAddress,
  type InteracAddress,
} from "@/hooks/firestore/models/interac/interacAddress";
import { useFirestore } from "@/hooks/firestore/core/useFirestore";

// Stable fallback while data is loading
const stableEmptyResults: InteracAddress[] = [];

export const useInteracAddresses = () => {
  const { data, isLoading, error } = useFirestore(
    "/users/{userId}/gigadatInteracAddresses",
    interacAddress.array(),
  );

  return {
    interacAddresses: data ?? stableEmptyResults,
    isLoading,
    error,
  } as const;
};
